<div class="card" *ngFor="let fabricante of listaFornecedores">

    <div class="card-header">
        <div class="row">
            <div class="col-sm-8 cells">
                <h6 class="mb-0"> {{fabricante.nome}} - {{fabricante.cnpj | bnMask: 'CNPJ'}}</h6>
            </div>
        </div>
    </div>
    <bn-paginacao
    [total]="fabricante.paginacaoEquipamentos.itens.length"
    [tamanhoPagina]="fabricante.paginacaoEquipamentos.parametros.pageSize"
    [numPagina]="fabricante.paginacaoEquipamentos.parametros.page"
    [opcoesTamanhoPagina]="fabricante.paginacaoEquipamentos.tamanhosPagina"
    (aoMudar)="fabricante.paginacaoEquipamentos.aoMudar($event)" class="w-100">
        <div class="card-body">
            <div class="card" *ngFor="let equipamento of fabricante.paginacao.itensPagina">
                <div class="card-header">
                    <div class="row">
                        <div class="col-sm-8 cells">
                            <h6 class="mb-0">{{equipamento.codigoProdutoCfi}} - {{equipamento.descricaoEquipamento}}</h6>
                        </div>
                    </div>
                </div>
                <div class="card-body">
    
                    <div class="row">
                        <div class="col-sm-2 cells label">
                            <h6 class="mb-0">Item RDME:</h6>
                        </div>
                        <div class="col-sm-1 cells">
                            <p>{{equipamento.numeroItemRdme  || '-'}}</p>
                        </div>
                        
                        <div class="col-sm-1 cells label">
                            <h6 class="mb-0">Qtd:</h6>
                        </div>
                        <div class="col-sm-1 cells">
                            <p>{{equipamento.quantidade  || '-'}}</p>
                        </div>
    
                        <div class="col-sm-2 cells label label-2">
                            <h6 class="mb-0">Item CE:</h6>
                        </div>
                        <div class="col-sm-1 cells">
                            <p>{{equipamento.numeroItemCe  || '-'}}</p>
                        </div>
                    </div>
    
                    <div class="row">
                        <div class="col-sm-2 cells label">
                            <h6 class="mb-0">Valor Unitário:</h6>
                        </div>
                        <div class="col-sm-2 cells">
                            <p>{{(getValorUnitarioTotalEquipamento(equipamento) || 0) | bnMask: 'MOEDA'}}</p>
                        </div>
                        
                        <div class="col-sm-3 cells label label-2">
                            <h6 class="mb-0">Valor Unitário Financiado:</h6>
                        </div>
                        <div class="col-sm-2 cells">
                            <p>{{(getValorUnitarioFinanciadoEquipamento(equipamento) || 0) | bnMask: 'MOEDA'}}</p>
                        </div>
                    </div>
    
                    <div class="row">
                        
                        <div class="col-sm-2 cells label">
                            <h6 class="mb-0">Valor Total:</h6>
                        </div>
                        <div class="col-sm-2 cells">
                            <p>{{(equipamento.valorTotal || 0) | bnMask: 'MOEDA'}}</p>
                        </div>
    
                        <div class="col-sm-3 cells label label-2">
                            <h6 class="mb-0">Valor Total Financiado:</h6>
                        </div>
                        <div class="col-sm-2 cells">
                            <p>{{(equipamento.valorTotalFinanciado || 0) | bnMask: 'MOEDA'}}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2 cells label">
                            <h6 class="mb-0">Posição Cadastral:</h6>
                        </div>
                        <div class="col-sm-2 cells">
                            <p>{{equipamento.posicaoCadastral || '-'}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </bn-paginacao>
</div>